import { render } from "./ModalCustomer.vue?vue&type=template&id=3fe37a71"
import script from "./ModalCustomer.vue?vue&type=script&lang=js"
export * from "./ModalCustomer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__